import React from "react";
import { Handle } from "reactflow";

const DataNode = ({ id, data }) => {
  const statusStyles = {
    idle: "",
    pending: "border-yellow-400",
    queued: "border-blue-400",
    failed: "border-red-500",
    success: "border-green-500",
    running: "animate-[pulse_1s_infinite] border-green-500",
    approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
    diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
  };
  
  const status = data?.status || "idle";
  const borderColorClass = statusStyles[status].replace("border-", "") || "";
  
  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: "180px", height: "140px" }}
    >
      {/* SVG Cylinder */}
      <svg width="150" height="120" viewBox="0 0 150 120">
        {/* Cylinder body */}
        <rect
          x="15"
          y="20"
          width="120"
          height="80"
          fill="#27272a"
          stroke="#fff"
          strokeWidth="1"
          className={borderColorClass ? `stroke-${borderColorClass}` : ""}
        />
        {/* Cylinder top ellipse */}
        <ellipse
          cx="75"
          cy="20"
          rx="60"
          ry="15"
          fill="#27272a"
          stroke="#fff"
          strokeWidth="1"
          className={borderColorClass ? `stroke-${borderColorClass}` : ""}
        />
        {/* Cylinder bottom ellipse */}
        <ellipse
          cx="75"
          cy="100"
          rx="60"
          ry="15"
          fill="#27272a"
          stroke="#fff"
          strokeWidth="1"
          className={borderColorClass ? `stroke-${borderColorClass}` : ""}
        />
        
        {/* Text content */}
        <foreignObject x="15" y="40" width="120" height="40">
          <div xmlns="http://www.w3.org/1999/xhtml" className="w-full h-full flex items-center justify-center">
            <div className="text-white text-sm font-medium text-center overflow-hidden text-ellipsis px-2">
              {data?.selectedSource?.original_filename || "File 1"}
            </div>
          </div>
        </foreignObject>
      </svg>
      
      {/* Handle for connections */}
      <Handle
        type="source"
        position="bottom"
        className="!bg-blue-400 border-none"
        style={{ bottom: '10px', left: '50%', transform: 'translateX(-50%)', height: "10px", width: "10px" }}
      />
    </div>
  );
};

export default DataNode;